export default "__VITE_ASSET__BURKn5t0__"